import { render, staticRenderFns } from "./VFileInputError.vue?vue&type=template&id=4c24c6e1&scoped=true"
import script from "./VFileInputError.vue?vue&type=script&lang=js"
export * from "./VFileInputError.vue?vue&type=script&lang=js"
import style0 from "./VFileInputError.vue?vue&type=style&index=0&id=4c24c6e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24c6e1",
  null
  
)

export default component.exports